import { UserFavorite } from '@engelvoelkersamericas/api';
import isObjectEmpty from '@util/isObjectEmpty';

export const getSavePropertiesIdsByUserIdFromLS = (userId) => {
  if (userId) {
    let ids: any = localStorage.getItem('favProperties');
    if (ids) {
      ids = JSON.parse(ids);
      if (ids.userId === userId) {
        return ids;
      }
    }
  }
  return null;
};

export const getUserSavePropertyDetailsByListingIdFromLS = (userId: string, listingId: string) => {
  if (userId && listingId) {
    const alreadySaveProperties = getSavePropertiesIdsByUserIdFromLS(userId);
    if (
      alreadySaveProperties &&
      !isObjectEmpty(alreadySaveProperties?.savePropertyIds) &&
      alreadySaveProperties?.savePropertyIds[listingId]
    ) {
      return alreadySaveProperties.savePropertyIds[listingId];
    } else {
      return '';
    }
  }
  return '';
};

export const savePropertiesIdsByUserId = (userId: string, listings: UserFavorite[]) => {
  if (userId && listings && listings.length) {
    const alreadySaveProperties = getSavePropertiesIdsByUserIdFromLS(userId);
    let savePropertyIds = !isObjectEmpty(alreadySaveProperties)
      ? { ...alreadySaveProperties.savePropertyIds }
      : {};
    listings.map((fpi) => {
      if (fpi.ListingId) {
        savePropertyIds = { ...savePropertyIds, [fpi.ListingId]: fpi };
      }
    });
    localStorage.setItem('favProperties', JSON.stringify({ userId, savePropertyIds }));
  }
};

export const deleteAllSavedPropertiesIdFromLS = () => {
  localStorage.removeItem('favProperties');
};

export const removePropertyFromLS = async (userId, listingId) => {
  if (userId && listingId) {
    const alreadySaveProperties = await getSavePropertiesIdsByUserIdFromLS(userId);
    if (
      !isObjectEmpty(alreadySaveProperties.savePropertyIds) &&
      alreadySaveProperties.savePropertyIds[listingId]
    ) {
      delete alreadySaveProperties.savePropertyIds[listingId];
      localStorage.setItem('favProperties', JSON.stringify({ ...alreadySaveProperties }));
    }
  }
};
